<div class="modal__content">
    <p>No address is found.</p>
    <p>Click "Continue" to add new address.</p>
</div>
<div class="modal__actions">
    <button class="button" (click)="accept()">Continue</button>
</div>
